/**
 * Feature Flags Configuration
 * 
 * This file controls feature visibility across the application
 */

// Feature flag definitions
export const FEATURES = {
  ANALYTICS_DASHBOARD: {
    enabled: true, // Set to false to disable for all users
    whitelistedEmails: [
      'ramanandt@gmail.com',
      'karthick.dew@gmail.com',
      'a1009us@gmail.com'
      // Add more emails as needed
    ]
  },
  WALLET_TAB: {
    enabled: true, // Set to false to disable wallet tab for all users
    whitelistedEmails: [      // Leave empty to enable for all users, or add specific emails
    ]
  }
};

/**
 * Check if a feature is enabled for a specific user
 * @param {string} featureName - The feature name from FEATURES
 * @param {object} user - User object with email property
 * @returns {boolean} - Whether the feature is enabled for this user
 */
export const isFeatureEnabled = (featureName, user) => {
  const feature = FEATURES[featureName];
  
  if (!feature) {
    console.warn(`Feature "${featureName}" not found in feature flags`);
    return false;
  }
  
  // If feature is globally disabled, return false
  if (!feature.enabled) {
    return false;
  }
  
  // If no whitelist is defined, allow all users
  if (!feature.whitelistedEmails || feature.whitelistedEmails.length === 0) {
    return true;
  }
  
  // Check if user's email is in the whitelist
  const userEmail = user?.email || user?.username || '';
  return feature.whitelistedEmails.includes(userEmail.toLowerCase());
};

/**
 * Get all whitelisted emails for a feature
 * @param {string} featureName - The feature name from FEATURES
 * @returns {Array} - Array of whitelisted emails
 */
export const getWhitelistedEmails = (featureName) => {
  const feature = FEATURES[featureName];
  return feature?.whitelistedEmails || [];
};

/**
 * Admin utility to add email to whitelist (use in admin panel)
 * @param {string} featureName - The feature name from FEATURES
 * @param {string} email - Email to add to whitelist
 */
export const addToWhitelist = (featureName, email) => {
  const feature = FEATURES[featureName];
  if (feature && !feature.whitelistedEmails.includes(email.toLowerCase())) {
    feature.whitelistedEmails.push(email.toLowerCase());
    console.log(`Added ${email} to ${featureName} whitelist`);
  }
};
